import React, { useEffect } from "react";
import { Callout } from 'react-foundation'
import { useFormikContext } from 'formik'
import has from 'lodash/has'
type SubmitButtonProps = { text?: string, notHTMLSubmit?: boolean, onClick?: React.MouseEventHandler<HTMLButtonElement> }

const SubmitButton: React.FC<SubmitButtonProps> = ({ text, notHTMLSubmit, onClick }) => {
    const { isSubmitting } = useFormikContext()

    return (
        <button className='button filter' type={notHTMLSubmit ? 'button' : 'submit'} disabled={isSubmitting} onClick={onClick}>
            {text ?? 'Submit'}
            {isSubmitting && <img src="/spinning-circles.svg" alt="loading" style={{ height: '1rem', marginLeft: 15 }} />}
        </button>
    )
}

type SubmitMessageProps = { successMessage?: string, duration?:number }

export const SubmitMessage: React.FC<SubmitMessageProps> = ({ successMessage, duration = 5 }) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const { isSubmitting, status, setStatus } = useFormikContext()

    useEffect(() => { if (isSubmitting) setStatus(undefined) }, [isSubmitting, setStatus])

    useEffect(() => {
        if (has(status, 'success') || has(status, 'error')) {
            const timer = setTimeout(() => {
                setStatus(undefined);
            }, duration * 1000);
            return () => clearTimeout(timer);
        }
    }, [status, duration, setStatus]);

    if (isSubmitting) return null
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (has(status, 'error')) return <Callout color='alert'>{status.error ?? 'There was an issue processing your request'}</Callout>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (has(status, 'success')) return <Callout color='success'>{successMessage || status.success}</Callout>

    return null
}

export default SubmitButton

